import {
  DailyWorkdayDurationFilters,
  DailyWorkdayDurationFiltersState,
  FormattedTransportDailyWorkdayDurationReportItemDTO,
  TransportDailyWorkdayDurationReportItemDTO,
} from '../types';
import { getTimezone, getWeekdayFromDate } from '../../../../global/utils';
import { formatReportPayloadDate } from '../../../utils/helpers';
import { getDuration } from '../../../../shared/utils';

export const formatDailyWorkdayDurationReportItem = (
  reportItem: TransportDailyWorkdayDurationReportItemDTO,
): FormattedTransportDailyWorkdayDurationReportItemDTO => {
  return {
    ...reportItem,
    id: crypto.randomUUID(),
    weekday: reportItem.date
      ? getWeekdayFromDate(new Date(reportItem.date))
      : null,
    durationFormmated: reportItem.duration
      ? getDuration(reportItem.duration)
      : null,
  };
};

export const formatDailyWorkdayDurationReportPayload = (
  filters: DailyWorkdayDurationFiltersState,
): DailyWorkdayDurationFilters => {
  return {
    transports: filters.transports,
    hideMissingDays: filters.hideMissingDays,
    showWeekdaysOnly: filters.showWeekdaysOnly,
    start: formatReportPayloadDate(filters.start),
    end: formatReportPayloadDate(filters.end),
    tz: getTimezone(),
  };
};
